//基础信息
export default [
  {
    path: '/storeGoods',
    component: resolve => require(['../pages/store/storeGoods.vue'], resolve),
    name: 'storeGoods',
    title: "商品管理",
    meta: {
      title: "商品管理"
    }
  },
  {
    path: '/ticketManage',
    component: resolve => require(['../pages/store/ticketManage.vue'], resolve),
    name: 'ticketManage',
    title: "票务管理",
    meta: {
      title: "票务管理"
    }
  },
  {
    path: '/storeType',
    component: resolve => require(['../pages/store/storeType.vue'], resolve),
    name: 'storeType',
    title: "潮玩分类",
    meta: {
      title: "潮玩分类"
    }
  },
  {
    path: '/userCard',
    component: resolve => require(['../pages/store/userCard.vue'], resolve),
    name: 'userCard',
    title: "店铺消费管理",
    meta: {
      title: "店铺消费管理"
    }
  },
  {
    path: '/orderStore',
    component: resolve => require(['../pages/store/orderStore.vue'], resolve),
    name: 'orderStore',
    title: "小程序票务订单",
    meta: {
      title: "小程序票务订单"
    }
  },
  {
    path: '/artShowManage',
    component: resolve => require(['../pages/store/artShowManage.vue'], resolve),
    name: 'artShowManage',
    title: "画展管理",
    meta: {
      title: "画展管理"
    }
  }
];
